import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { WizImageModule } from '../../../components/controls/wiz-image/wiz-image.module';
import { WizLabelModule } from '../../../components/controls/wiz-label/wiz-label.module';
import { WizLayoutModule } from '../../../components/layouts/wiz-layout.module';
import { WizStylingDirectiveModule } from '../../../directives/styling/wiz-styling-directives.module';
import { WizItemRendererModule } from '../../../interfaces/wiz-item-renderer';
import { WizButtonModule } from '../button/wiz-button.module';
import { WizAutocompleteTrigger } from './wiz-autocomplete-directive';
import { WizDropdown } from './wiz-dropdown';

@NgModule({
  declarations: [WizDropdown, WizAutocompleteTrigger],
  imports: [
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    WizButtonModule,
    WizLayoutModule,
    WizImageModule,
    WizLabelModule,
    WizStylingDirectiveModule,
    WizItemRendererModule,
    MatAutocompleteModule,
  ],
  exports: [WizDropdown, WizAutocompleteTrigger],
})
export class WizDropdownModule {}
